export default __webpack_public_path__ + "static/media/playlistChecked.3cc29ef6.svg";